export default class Tabs {
    protected tabs: NodeListOf<HTMLElement> = null;
    protected container: HTMLElement = null;
    constructor(container = null) {
        if (!container) {
            this.container = document.body;
        } else {
            this.container = container;
        }

        this.tabs = this.container.querySelectorAll('.tabs, .list-tabs');
        if (!this.tabs.length) {
            return;
        }
        this.setup();
    }

    setup() {
        const _this = this;
        _this.tabs.forEach((tab) => {
            tab.querySelectorAll('ul.tabs-nav li, ul.nav-tabs li').forEach((li: HTMLElement, index: number) => {
                li.addEventListener('click', () => _this.activate(tab, li, index));
            });
        });
    }

    activate(tab: HTMLElement, el: HTMLElement, activeIndex: number) {
        tab.querySelectorAll('ul.tabs-nav li.active, ul.nav-tabs li.active').forEach((li: HTMLElement) => {
            li.classList.remove('active');
        });
        el.classList.add('active');
        tab.querySelectorAll('.tab-pane').forEach( (tabItem: HTMLElement, currentIndex: number) => {
            if (currentIndex !== activeIndex) {
                tabItem.classList.remove('active');
            } else {
                tabItem.classList.add('active');
            }
        });
        tab.querySelectorAll('.tab-item').forEach((tabItem: HTMLElement, currentIndex: number) => {
            if (currentIndex !== activeIndex) {
                tabItem.classList.add('hidden');
            } else {
                tabItem.classList.remove('hidden');
            }
        });
    }
}
